module.exports = __webpack_public_path__ + "app-static/img/18.15355372.png";